import { PermissionsFolderAccessProfile } from '@/modules/drive/domain/models/PermissionsAccessProfile'

import { axios, Response } from '../index'

const getPermissionsFolderAccessProfile = (
  folderId: string
): Response<PermissionsFolderAccessProfile[]> => {
  return axios.get(`/v1/folders/${folderId}/profiles-permissions`)
}

export default getPermissionsFolderAccessProfile
